(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InvoiceInfoPaymentLogDialogController', InvoiceInfoPaymentLogDialogController);

    InvoiceInfoPaymentLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaymentLog', 'InvoiceInfo', 'PaymentLogCustom'];

    function InvoiceInfoPaymentLogDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, PaymentLog, InvoiceInfo, PaymentLogCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.paymentLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.paymentLog.receiptPay = true;
        //vm.invoiceinfos =

        vm.closeModal = closeModal;
        vm.okModal = okModal;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.paymentLog.id !== null) {
                    //PaymentLog.update(vm.paymentLog, onSaveSuccess, onSaveError);
                } else {
                    if (vm.paymentLog.receiptPay == false)
                        vm.paymentLog.amount = -vm.paymentLog.amount;

                    PaymentLogCustom.createPaymentLogByInvoiceInfoId().save(vm.paymentLog, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {

            $scope.$emit('tikonApp:paymentLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        function closeModal() {
            clear();

        }

        function okModal() {
            save();
        }

    }
})();
